import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

const mockLeftGrid = [
  {
    image: '/highlights/3.jpg',
    description: 'The classroom in the centre is spacious which provides students with more freedom in movement and comfort.'
  },
  {
    image: '/highlights/1.jpg',
    description: 'Caring staff assist with picking up and dropping off students at the school. We provide our own hats and umbrellas.'
  },
  {
    image: '/highlights/2.jpg',
    description: 'Lunch box are provided for students who have after school activities and staff will pick students up after their activities end.'
  },
 ];
 
 const mockMiddleGrid = [
  {
    image: '/highlights/6.jpg',
    description: 'Delicious and healthy food is offered, with a frequently changing menu and a different pre-meal fruit each day.'
  },
  {
    image: '/highlights/4.jpg',
    description: 'A team of professional teachers, led by a principal who previously served as the vice principal of Han Language Tampines PTE. LTD. Students are closely monitored to complete their assignments on time, including English & Chinese spelling.'
  },
  {
    image: '/highlights/5.jpg',
    description: 'Conveniently located, with easy access for pick-up, drop-off, and school bus services.'
  }, 
 ];
 
 const mockRightGrid = [
  {
    image: 'https://www.msf.gov.sg/ResourcePackages/Msf/assets/img/msf-logo.png',
    description: 'Registered under MSF, able to apply for government subsidies for families in need.'
  },
  {
    image: '/highlights/8.jpg',
    description: 'Affordable, high-quality tutoring courses, organized by grade level and subject-based, designed to effectively improve academic performance.'
  },
  {
    image: '/highlights/9.jpg',
    description: 'Provide students with a comfortable space to shower and change, allowing them to feel refreshed for the rest of the afternoon. There is separate shower cubicles and toilet for males and females.'
  }
 ];

const Column = ({ data }) => {
  const theme = useTheme();
  return (
    <Box>
      {data.map((item, i) => (
        <Box
          key={i}
          sx={{
            marginBottom: { xs: 2, sm: 3 },
            '&:last-child': { marginBottom: 0 },
          }}
        >
          <Box
            boxShadow={1}
            sx={{
              position: 'relative',
              overflow: 'hidden',
              borderRadius: 2,
              '&:hover': {
                '& img': {
                  transform: 'scale(1.2)',
                },
                '& .portfolio-massonry__main-item': {
                  bottom: 0,
                },
              },
            }}
          >
            <Box
              component={'img'}
              loading="lazy"
              height={1}
              width={1}
              src={item.image}
              alt="..."
              maxHeight={{ xs: 400, sm: 600, md: 1 }}
              sx={{
                transition: 'transform .7s ease !important',
                transform: 'scale(1.0)',
                objectFit: 'cover',
                filter:
                  theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
              }}
            />
            <Box
              position={'absolute'}
              bottom={'-100%'}
              left={0}
              right={0}
              padding={2}
              bgcolor={'background.paper'}
              className={'portfolio-massonry__main-item'}
              sx={{ transition: 'bottom 0.3s ease 0s' }}
            >
              <Box
                component={'svg'}
                preserveAspectRatio="none"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 1920 100.1"
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  transform: 'translateY(-90%)',
                  zIndex: 2,
                  width: 1,
                }}
              >
                <path
                  fill={theme.palette.background.paper}
                  d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"
                ></path>
              </Box>
              <Typography>{item.description}</Typography>
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

Column.propTypes = {
  data: PropTypes.array.isRequired,
};

const Main = () => {
  return (
    <Box>
      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
          <Column data={mockLeftGrid} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Column data={mockMiddleGrid} />
        </Grid>
        <Grid item xs={12} md={4}>
          <Column data={mockRightGrid} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Main;
